import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { LegendLabelText } from "@similarweb/ui-components";

import { FlexColumn, FlexRowFlexStart } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const SERPTrafficDistributionWrapper = styled(FlexColumn)`
    padding: 24px;
    color: ${colorsPalettes.carbon[500]};
    ${LegendLabelText} {
        color: ${colorsPalettes.carbon[500]};
    }
`;

export const SERPTrafficDistributionLegendsWrapper = styled(FlexRowFlexStart)`
    height: 32px;
`;

export const LegendWrapper = styled.div`
    margin-right: 12px;
`;
